import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { FiltrosReportesComponent } from './components/filtros-reportes/filtros-reportes.component';
import { FiltrosReportesMultiComponent } from './components/filtros-reportes-multi/filtros-reportes-multi.component';
import { FiltrosTecnicosComponent } from './components/filtros-tecnicos/filtros-tecnicos.component';
import { MaterialModalComponent } from './components/material-modal/material-modal.component';
import { ClienteModalComponent } from './components/cliente-modal/cliente-modal.component';
import { SimpleAccordionModule } from 'src/app/shared/components/simple-accordion/simple-accordion.module';

@NgModule({
  declarations: [
    FiltrosReportesComponent,
    FiltrosTecnicosComponent,
    FiltrosReportesMultiComponent,
    MaterialModalComponent,
    ClienteModalComponent,
    FiltrosTecnicosComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    SimpleAccordionModule
  ],
  exports: [
    FiltrosReportesComponent,
    FiltrosTecnicosComponent,
    FiltrosReportesMultiComponent,
    MaterialModalComponent,
    ClienteModalComponent,
    FiltrosTecnicosComponent
  ]
})
export class SharedModule { }
